import React, { useState } from 'react'
import { styled } from '@mui/material/styles'
import { useIntl } from 'react-intl'
import { Box, Tooltip, CircularProgress, Typography } from '@mui/material'

import { useIPCalls } from '../../hooks/ip-calls.hook'
import { useCombos } from '../../../combos'

const StyledTypography = styled(Typography)(({ theme }) => ({}))

export const IPCellCUPS = (props) => {
  const { formatMessage, formatDate } = useIntl()
  const rowData = props.row.original
  const cups = rowData?.cups
  const combos = useCombos(['estados_inspeccion'])
  const { getCUPSEventsCall } = useIPCalls()

  const [open, setOpen] = useState(false)
  const [events, setEvents] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(false)

  const handleClose = () => setOpen(false)

  const handleOpen = () => {
    setLoading(true)
    setError(false)
    setOpen(true)
    getCUPSEventsCall(cups)
      .then(({ data }) => {
        setEvents(data)
        setLoading(false)
      })
      .catch(() => {
        setError(true)
        setLoading(false)
      })
  }

  const CUPSEvents = () => {
    if (loading) {
      return (
        <Box display="flex" justifyContent="center" alignItems="center" height={60} width={60}>
          <CircularProgress size={20} color="inherit" />
        </Box>
      )
    } else if (error) {
      return formatMessage({ id: 'pages.ip.table.columns.cupsCustom.tooltip.error' })
    } else {
      return events.map((event, index) => {
        const state = combos.estados_inspeccion.data.find(
          (option) => option.key === event.estado
        )?.value
        return (
          <Box key={index} display="flex">
            {' '}
            <StyledTypography display="inline">
              [{formatDate(new Date(event.fecha_inspeccion))}] {state || '--'}{' '}
              {event.motivo_rechazo ? '(' + event.motivo_rechazo + ')' : ''}
            </StyledTypography>
          </Box>
        )
      })
    }
  }

  return cups ? (
    <Tooltip arrow open={open} onClose={handleClose} onOpen={handleOpen} title={<CUPSEvents />}>
      <Typography variant="subtitle2" color="primary">
        {cups}
      </Typography>
    </Tooltip>
  ) : rowData?.codigo_instalacion ? ( // CAMBIO: Usa la variable `rowData`
    <Typography variant="body2" color="textSecondary">
      {rowData.codigo_instalacion}
    </Typography>
  ) : null
}
